// extracted by mini-css-extract-plugin
module.exports = {"title":"_3o9dc1mbopFd","price":"_1Sz-EXxPHWP6","flight":"_2hjxDJzjlzdg"};